import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { CmsFormPanel, PanelContent, PanelHeader, PanelTitle, PanelTrigger } from '@/components/shared/CmsFormPanel';
import { Plus } from 'lucide-react';
import { ConfirmDialog } from '@/components/shared';
import type { Organizer, OrganizerFormData } from './organizersmanager.props';

interface OrganizersFormDialogProps {
  isDialogOpen: boolean;
  setIsDialogOpen: (open: boolean) => void;
  editingOrganizer: Organizer | null;
  setEditingOrganizer: (o: Organizer | null) => void;
  formData: OrganizerFormData;
  setFormData: (data: OrganizerFormData) => void;
  handleSubmit: (e: React.FormEvent) => void;
  deleteTarget: any;
  setDeleteTarget: (target: any) => void;
  confirmDelete: () => void;
}

const OrganizersFormDialog: React.FC<OrganizersFormDialogProps> = ({
  isDialogOpen, setIsDialogOpen, editingOrganizer, setEditingOrganizer,
  formData, setFormData, handleSubmit, deleteTarget, setDeleteTarget, confirmDelete,
}) => (
  <>
    <CmsFormPanel open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <PanelTrigger asChild>
        <Button onClick={() => setEditingOrganizer(null)}>
          <Plus className="w-4 h-4 mr-2" />
          Додај организатор
        </Button>
      </PanelTrigger>
      <PanelContent>
        <PanelHeader>
          <PanelTitle>
            {editingOrganizer ? 'Измени организатор' : 'Додај нов организатор'}
          </PanelTitle>
        </PanelHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="name">Име *</Label>
            <Input id="name" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required />
          </div>
          <div>
            <Label htmlFor="description">Опис *</Label>
            <Textarea id="description" value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} rows={3} required />
          </div>
          <div>
            <Label htmlFor="logo">URL на лого *</Label>
            <Input id="logo" value={formData.logo} onChange={(e) => setFormData({ ...formData, logo: e.target.value })} placeholder="https://example.com/logo.jpg" required />
          </div>
          <div>
            <Label htmlFor="website">Веб-сајт *</Label>
            <Input id="website" value={formData.website} onChange={(e) => setFormData({ ...formData, website: e.target.value })} placeholder="https://example.com" required />
          </div>
          <div>
            <Label htmlFor="email">Е-пошта *</Label>
            <Input id="email" type="email" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} placeholder="organizer@example.com" required disabled={!!editingOrganizer} />
          </div>
          {!editingOrganizer && (
            <div>
              <Label htmlFor="password">Лозинка *</Label>
              <Input id="password" type="password" value={formData.password} onChange={(e) => setFormData({ ...formData, password: e.target.value })} placeholder="Минимум 6 карактери" required minLength={6} />
            </div>
          )}
          <div className="flex justify-end space-x-2 pt-4">
            <Button type="button" variant="outline" onClick={() => setIsDialogOpen(false)}>Откажи</Button>
            <Button type="submit">{editingOrganizer ? 'Зачувај промени' : 'Креирај организатор'}</Button>
          </div>
        </form>
      </PanelContent>
    </CmsFormPanel>
    <ConfirmDialog
      open={deleteTarget !== null}
      onOpenChange={(open) => !open && setDeleteTarget(null)}
      title="Избриши организатор"
      description="Дали сте сигурни дека сакате да го избришете овој организатор?"
      onConfirm={confirmDelete}
    />
  </>
);

export default OrganizersFormDialog;
